module.exports = __webpack_public_path__ + "img/updateadi.a3d0d3f4.webp";